"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Location = /** @class */ (function () {
    function Location() {
    }
    Location.location = function () {
        if (typeof window !== 'undefined' &&
            window.location &&
            window.location.hostname) {
            var isWww = window.location.hostname.startsWith('www');
            var isAida = window.location.hostname.startsWith('aida');
            if (isWww || isAida) {
                return 'chat94.realperson.de'; // production
            }
        }
        return 'staging94.realperson.de'; // stage
    };
    return Location;
}());
exports.Location = Location;
//# sourceMappingURL=location.js.map